import { DEFAULT_COMPLEX_SIZE } from '../../constants'
import { applySize } from '../Size/utils'
import type { PxSizesValueType, SizesValueType } from './types'

export const safeParsePxSizes = (value?: string | null): PxSizesValueType => {
  try {
    return JSON.parse(value || DEFAULT_COMPLEX_SIZE || '""')
  } catch {
    return JSON.parse(DEFAULT_COMPLEX_SIZE || '""')
  }
}

export const applyPxSizes = (size?: PxSizesValueType | string | null): string | null => {
  const value =
    (typeof size === 'string' ? safeParsePxSizes(size) : size) ||
    safeParsePxSizes(DEFAULT_COMPLEX_SIZE)
  return value.map((size) => `${size || 0}px`).join(' ')
}

export const savePxSizes = (value?: PxSizesValueType | null) =>
  value ? JSON.stringify(value) : null

export const sumSizes = (
  indents1?: PxSizesValueType | string | null,
  indents2?: PxSizesValueType | string | null,
): PxSizesValueType => {
  const a =
    typeof indents1 === 'string'
      ? safeParsePxSizes(indents1)
      : indents1 || safeParsePxSizes(DEFAULT_COMPLEX_SIZE)
  const b =
    typeof indents2 === 'string'
      ? safeParsePxSizes(indents2)
      : indents2 || safeParsePxSizes(DEFAULT_COMPLEX_SIZE)
  return a.map((value, index) => (value || 0) + (b[index] || 0)) as PxSizesValueType
}

export const safeParseSizes = (value?: string | null): SizesValueType => {
  try {
    return JSON.parse(value || DEFAULT_COMPLEX_SIZE || '""')
  } catch {
    return JSON.parse(DEFAULT_COMPLEX_SIZE || '""')
  }
}

export const applySizes = (size?: SizesValueType | string | null): string | null => {
  const value =
    (typeof size === 'string' ? safeParseSizes(size) : size) || safeParseSizes(DEFAULT_COMPLEX_SIZE)
  return value.map((v) => applySize(v) || '0px').join(' ')
}

export const saveSizes = (value?: SizesValueType | null) => (value ? JSON.stringify(value) : null)
